(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  const desktopSection = document.querySelector(".about-feature-section.desktop");
  const mobileSection = document.querySelector(".about-feature-section.mobile");
  const mediaQuery = window.matchMedia("(min-width: 1051px)");

  function initDesktop() {
    if (!desktopSection) return;

    const features = Array.from(desktopSection.querySelectorAll(".feature-content"));
    const steps = Array.from(desktopSection.querySelectorAll(".scroll-step"));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = entry.target.dataset.index;
            features.forEach((f, i) => {
              f.classList.toggle("active", i == index);
            });
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    steps.forEach((step) => observer.observe(step));
  }

  function initMobile() {
    if (!mobileSection) return;

    mobileSection.querySelectorAll(".feature-content").forEach((el) =>
      el.classList.add("active")
    );
  }

  // Initial setup
  if (mediaQuery.matches) {
    initDesktop();
  } else {
    initMobile();
  }

  // Optional: re-check if screen size changes
  mediaQuery.addEventListener("change", (e) => {
    if (e.matches) {
      location.reload(); // safest way to re-initialize if layout structure changes
    } else {
      location.reload();
    }
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisans-features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const section   = document.querySelector(".artisans-features");
  if (!section) return;

  const menuItems = Array.from(section.querySelectorAll(".artisan-menu-item"));
  const bios      = Array.from(section.querySelectorAll(".artisan-bio-item"));
  const menuWrap  = section.querySelector(".artisans-menu");

  let current = 0;

  function showIndex(i, opts = {}) {
    if (!bios.length) return;

    // wrap index
    i = (i + bios.length) % bios.length;
    current = i;

    // clear states
    menuItems.forEach(mi => mi.classList.remove("active"));
    bios.forEach(b => { b.classList.remove("active"); b.classList.add("hidden"); });

    // activate current
    const activeMenu = menuItems[i];
    const activeBio  = bios[i];

    if (activeMenu) activeMenu.classList.add("active");
    if (activeBio) {
      activeBio.classList.remove("hidden");
      void activeBio.offsetWidth; // reflow to enable transition
      activeBio.classList.add("active");
    }

    // keep the active menu item in view
    if (!opts.suppressScroll && activeMenu && menuWrap) {
      const isMobileHorizontal = window.matchMedia("(max-width: 600px)").matches;

      if (isMobileHorizontal) {
        // horizontal scroll on mobile
        menuWrap.scrollTo({
          left: activeMenu.offsetLeft - menuWrap.clientWidth * 0.05,
          behavior: "smooth"
        });
      } else {
        // vertical scroll inside the left menu column ONLY
        // compute a target top so the item sits near the top with a little padding
        const targetTop = activeMenu.offsetTop - menuWrap.clientHeight * 0.1;
        menuWrap.scrollTo({
          top: Math.max(0, targetTop),
          behavior: "smooth"
        });
      }
    }

    // optional focus return for prev/next buttons
    if (opts.focusButton === "prev") {
      activeBio?.querySelector(".prev")?.focus();
    } else if (opts.focusButton === "next") {
      activeBio?.querySelector(".next")?.focus();
    }
  }

  // clicks on left menu items
  menuItems.forEach((item, idx) => {
    item.addEventListener("click", () => showIndex(idx));
  });

  // delegate clicks for .prev / .next
  section.addEventListener("click", (e) => {
    const prev = e.target.closest(".prev");
    const next = e.target.closest(".next");
    if (prev) {
      e.preventDefault();
      showIndex(current - 1, { focusButton: "prev" });
    } else if (next) {
      e.preventDefault();
      showIndex(current + 1, { focusButton: "next" });
    }
  });

  // make .prev / .next accessible as buttons
  section.querySelectorAll(".prev, .next").forEach(el => {
    el.setAttribute("role", "button");
    el.setAttribute("tabindex", "0");
  });

  // arrow key support when section is focused
  section.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft")  showIndex(current - 1, { focusButton: "prev" });
    if (e.key === "ArrowRight") showIndex(current + 1, { focusButton: "next" });
  });

  // initial render: do NOT auto-scroll anything
  showIndex(0, { suppressScroll: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["border-image"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener('DOMContentLoaded', function () {
    const target = document.querySelector('.border-image');

    if (!target) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5
      }
    );

    observer.observe(target);
  });



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 650) return;

  const containers = document.querySelectorAll(".fc-animate .fc-container");

  containers.forEach((el, index) => {
    el.style.setProperty('--index', index);
  });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-collage"] && !Shopify.designMode) return;
  try {
    


document.addEventListener("DOMContentLoaded", () => {
  // === PRODUCT SLIDER FUNCTIONALITY (unchanged) ===
  const container = document.querySelector(".img-text-collage .products-container");
  const products = Array.from(container.querySelectorAll(".img-text-collage .si-product"));
  const leftArrow = document.querySelector(".img-text-collage .left-arrow");
  const rightArrow = document.querySelector(".img-text-collage .right-arrow");

  let currentPage = 0;
  let itemsPerPage = 2;
  let totalPages = 1;
  let productWidth = 0;

  const updateLayout = () => {
    const productStyle = getComputedStyle(products[0]);
    const marginRight = parseFloat(productStyle.marginRight) || 0;
    productWidth = products[0].offsetWidth + marginRight;

    if (window.innerWidth < 650) {
      itemsPerPage = 1;
    } else if (window.innerWidth < 950) {
      itemsPerPage = 1;
    } else {
      itemsPerPage = 2;
    }

    totalPages = Math.ceil(products.length / itemsPerPage);
    updateArrowState();
    scrollToPage(currentPage);
  };

  const updateArrowState = () => {
    leftArrow.classList.toggle("disabled", currentPage === 0);
    rightArrow.classList.toggle("disabled", currentPage >= totalPages - 1);
  };

  const scrollToPage = (page) => {
    const scrollAmount = productWidth * itemsPerPage * page;
    container.scrollTo({ left: scrollAmount, behavior: "smooth" });
    updateArrowState();
  };

  rightArrow.addEventListener("click", () => {
    if (currentPage < totalPages - 1) {
      currentPage++;
      scrollToPage(currentPage);
    }
  });

  leftArrow.addEventListener("click", () => {
    if (currentPage > 0) {
      currentPage--;
      scrollToPage(currentPage);
    }
  });

  updateLayout();
  window.addEventListener("resize", updateLayout);

  // === SCROLL ANIMATIONS FOR DESKTOP ONLY ===
  if (window.innerWidth > 750) {
    const section = document.querySelector(".img-text-collage");
    const colRight = section.querySelector(".col-right");
    const imgProduct = section.querySelector(".img-product");
    const img3 = section.querySelector(".img3");

    // Apply initial styles
    [colRight, imgProduct, img3].forEach((el) => {
      el.style.opacity = "0";
      el.style.transform = "translateY(100vh)";
      el.style.willChange = "transform, opacity";
    });

    const animateOnScroll = () => {
  const rect = section.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const triggerPoint = windowHeight * 0.5;
  const scrollOffset = triggerPoint - rect.top;
const progress = Math.min(Math.max(scrollOffset / windowHeight, 0), 1);

  // Animate colRight: from 0 → 0.33
  const colProgress = Math.min(Math.max((progress - 0.0) / 0.33, 0), 1);
  colRight.style.transform = `translateY(${(1 - colProgress) * 100}vh)`;
  colRight.style.opacity = colProgress.toFixed(2);

  // Animate imgProduct: from 0.33 → 0.66
  const imgProductProgress = Math.min(Math.max((progress - 0.33) / 0.33, 0), 1);
  imgProduct.style.transform = `translateY(${(1 - imgProductProgress) * 100}vh)`;
  imgProduct.style.opacity = imgProductProgress.toFixed(2);

  // Animate img3: from 0.66 → 1.0
  const img3Progress = Math.min(Math.max((progress - 0.66) / 0.34, 0), 1);
  img3.style.transform = `translateY(${(1 - img3Progress) * 100}vh)`;
  img3.style.opacity = img3Progress.toFixed(2);
};


    window.addEventListener("scroll", animateOnScroll);
    window.addEventListener("load", animateOnScroll);

    // === FADE-IN OBSERVER FOR .border-wrapper AND .img5 ===
    const fadeInTargets = [
      ...document.querySelectorAll(".img-text-collage .border-wrapper, .img-text-collage .img5")
    ];

    fadeInTargets.forEach(el => {
      el.style.opacity = "0";
      el.style.transition = "opacity 0.8s ease";
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.5) {
          entry.target.style.opacity = "1";
        }
      });
    }, {
      threshold: 0.5 // Trigger when 50% of element is visible
    });

    fadeInTargets.forEach(el => observer.observe(el));
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll(".sc-title");

  titles.forEach((title) => {
    title.addEventListener("click", () => {
      const paragraph = title.nextElementSibling;
      if (paragraph) {
        paragraph.classList.toggle("open");
      }
    });
  });
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".product-slider .product-container");
  const blocks = Array.from(container.querySelectorAll(".product-slider .product-block"));
  const leftArrow = document.querySelector(".product-slider .left-arrow");
  const rightArrow = document.querySelector(".product-slider .right-arrow");

  if (!container || !blocks.length || !leftArrow || !rightArrow) return;

  // === ARROW SCROLLING ===
  const scrollAmount = container.clientWidth * 0.8; // Scroll ~80% of visible container

  const updateArrows = () => {
    const maxScroll = container.scrollWidth - container.clientWidth;
    leftArrow.classList.toggle("disabled", container.scrollLeft <= 0);
    rightArrow.classList.toggle("disabled", container.scrollLeft >= maxScroll - 1);
  };

  rightArrow.addEventListener("click", () => {
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  leftArrow.addEventListener("click", () => {
    container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });

  container.addEventListener("scroll", updateArrows);
  window.addEventListener("resize", updateArrows);
  updateArrows();

  // === RESPONSIVE FONT SIZING ===
  function fitHeadings() {
    const headings = document.querySelectorAll(".product-slider .text-container h2");
    if (!headings.length || window.innerWidth > 600) return;

    headings.forEach((heading) => {
      const parentWidth = heading.offsetWidth;
      let fontSize = 10;
      heading.style.fontSize = fontSize + "px";
      heading.style.whiteSpace = "nowrap";

      while (heading.scrollWidth < parentWidth && fontSize < 300) {
        fontSize++;
        heading.style.fontSize = fontSize + "px";
      }

      while (heading.scrollWidth > parentWidth && fontSize > 1) {
        fontSize--;
        heading.style.fontSize = fontSize + "px";
      }
    });
  }

  fitHeadings();
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 600) fitHeadings();
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-features"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener("DOMContentLoaded", function () {
    const slides = document.querySelectorAll(".project-features .project-content");
    const nextBtn = document.querySelector(".project-features .arrow-next");
    const prevBtn = document.querySelector(".project-features .arrow-back");
    let currentIndex = 0;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle("active", i === index);
      });
    }

    nextBtn.addEventListener("click", function () {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    });

    prevBtn.addEventListener("click", function () {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
    });
  });


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-returns-faq"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function () {
  // Initially hide all dropdowns
  $('.faqs .dropdown').hide();

  $('.faqs .heading').on('click', function () {
    const dropdown = $(this).next('.faqs .dropdown');
    const icon = $(this).find('.open');

    // Toggle the dropdown
    dropdown.slideToggle();

    // Toggle rotation class
    $(this).toggleClass('open');

    // Rotate the icon
    icon.toggleClass('rotated');
  });
});


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-image"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(".shoppable-image .products-container");
    const products = Array.from(container.querySelectorAll(".shoppable-image .si-product"));
    const leftArrow = document.querySelector(".shoppable-image .left-arrow");
    const rightArrow = document.querySelector(".shoppable-image .right-arrow");
    const shoppable = document.querySelector(".shoppable-image");
    const imageContainer = document.querySelector(".shoppable-image .image-container");

    let currentPage = 0;
    let itemsPerPage = getItemsPerPage();
    let totalPages = Math.ceil(products.length / itemsPerPage);

    function getItemsPerPage() {
      const width = window.innerWidth;
      if (width <= 550) return 1;
      if (width <= 700) return 2;
      if (width <= 1000) return 1;
      return 2;
    }

    function updateArrowState() {
      leftArrow.classList.toggle("disabled", currentPage === 0);
      rightArrow.classList.toggle("disabled", currentPage >= totalPages - 1);
    }

    function scrollToPage(page) {
      const productWidth = products[0].offsetWidth;
      const gap = parseFloat(getComputedStyle(container).columnGap || 0);
      const scrollAmount = page * (productWidth + gap) * itemsPerPage;
      container.scrollTo({ left: scrollAmount, behavior: "smooth" });
      updateArrowState();
    }

    function recalculateLayout() {
      itemsPerPage = getItemsPerPage();
      totalPages = Math.ceil(products.length / itemsPerPage);
      currentPage = Math.min(currentPage, totalPages - 1);
      scrollToPage(currentPage);
    }

    rightArrow.addEventListener("click", () => {
      if (currentPage < totalPages - 1) {
        currentPage++;
        scrollToPage(currentPage);
      }
    });

    leftArrow.addEventListener("click", () => {
      if (currentPage > 0) {
        currentPage--;
        scrollToPage(currentPage);
      }
    });

    window.addEventListener("resize", recalculateLayout);

    recalculateLayout();

    // === Fade in .image-container when .shoppable-image is visible
    function checkImageFadeIn() {
      if (!shoppable || !imageContainer) return;
      const rect = shoppable.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const threshold = windowHeight * 0.5;

      if (rect.top < threshold && rect.bottom > 0) {
        imageContainer.classList.add("visible");
        window.removeEventListener("scroll", checkImageFadeIn);
      }
    }

    window.addEventListener("scroll", checkImageFadeIn, { passive: true });
    checkImageFadeIn();


  });



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-products"] && !Shopify.designMode) return;
  try {
    

function fitStickyHeadings() {
  const headings = document.querySelectorAll(".sticky-products .text-container h3");
  if (!headings.length || window.innerWidth >= 650) return;

  headings.forEach(heading => {
    const parentWidth = heading.offsetWidth;
    let fontSize = 10;
    heading.style.fontSize = fontSize + "px";
    heading.style.whiteSpace = "nowrap";

    while (heading.scrollWidth < parentWidth && fontSize < 300) {
      fontSize++;
      heading.style.fontSize = fontSize + "px";
    }

    while (heading.scrollWidth > parentWidth && fontSize > 1) {
      fontSize--;
      heading.style.fontSize = fontSize + "px";
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  fitStickyHeadings();

  
});

window.addEventListener("resize", () => {
  if (window.innerWidth < 650) {
    fitStickyHeadings();
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-faqs"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function () {
  // Initially hide all dropdowns
  $('.dropdown').hide();

  $('.trade-faq .heading').on('click', function () {
    const dropdown = $(this).next('.dropdown');
    const icon = $(this).find('.open');

    // Toggle the dropdown
    dropdown.slideToggle();

    // Toggle rotation class
    $(this).toggleClass('open');

    // Rotate the icon
    icon.toggleClass('rotated');
  });
});


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-collage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  // === DESKTOP ONLY ===
  const isDesktop = () => window.innerWidth > 750;

  const section = document.querySelector(".travel-collage");
  if (!section) return;

  let colRight, imgProduct, img3;
  let onScrollHandler = null;

  // Keep track of which elements have "landed"
  const landed = {
    colRight: false,
    imgProduct: false,
    img3: false
  };

  function applyInitialStyles() {
    if (!isDesktop()) return;

    colRight   = section.querySelector(".col-right");
    imgProduct = section.querySelector(".img-product");
    img3       = section.querySelector(".img3");

    [colRight, imgProduct, img3].forEach((el) => {
      if (!el) return;
      el.style.opacity = "0";
      el.style.transform = "translateY(100vh)";
      el.style.willChange = "transform, opacity";
    });
  }

  function lock(elKey, elNode) {
    if (!elNode || landed[elKey]) return;
    landed[elKey] = true;
    elNode.style.transform = "translateY(0)";
    elNode.style.opacity = "1";
    elNode.style.willChange = "auto"; // free up memory

    // If all are locked, stop listening
    if (landed.colRight && landed.imgProduct && landed.img3 && onScrollHandler) {
      window.removeEventListener("scroll", onScrollHandler, { passive: true });
      onScrollHandler = null;
    }
  }

  function animateOnScroll() {
    if (!isDesktop() || !section) return;

    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const triggerPoint = windowHeight * 0.5;
    const scrollOffset = triggerPoint - rect.top;
    const progress = Math.min(Math.max(scrollOffset / windowHeight, 0), 1);

    // colRight: 0.00 → 0.33
    if (colRight && !landed.colRight) {
      const colProgress = Math.min(Math.max((progress - 0.0) / 0.33, 0), 1);
      if (colProgress >= 1) {
        lock("colRight", colRight);
      } else {
        colRight.style.transform = `translateY(${(1 - colProgress) * 100}vh)`;
        colRight.style.opacity = String(colProgress.toFixed(2));
      }
    }

    // imgProduct: 0.25 → 0.50 (kept your original spans but they were 0.25 width)
    if (imgProduct && !landed.imgProduct) {
      const imgProductProgress = Math.min(Math.max((progress - 0.25) / 0.25, 0), 1);
      if (imgProductProgress >= 1) {
        lock("imgProduct", imgProduct);
      } else {
        imgProduct.style.transform = `translateY(${(1 - imgProductProgress) * 100}vh)`;
        imgProduct.style.opacity = String(imgProductProgress.toFixed(2));
      }
    }

    // img3: 0.50 → 0.75
    if (img3 && !landed.img3) {
      const img3Progress = Math.min(Math.max((progress - 0.5) / 0.25, 0), 1);
      if (img3Progress >= 1) {
        lock("img3", img3);
      } else {
        img3.style.transform = `translateY(${(1 - img3Progress) * 100}vh)`;
        img3.style.opacity = String(img3Progress.toFixed(2));
      }
    }
  }

  function setupScroll() {
    if (!isDesktop()) return;
    // Reset flags on fresh setup
    landed.colRight = landed.imgProduct = landed.img3 = false;
    applyInitialStyles();

    // Bind scroll once, store reference so we can remove it later
    onScrollHandler = animateOnScroll;
    window.addEventListener("scroll", onScrollHandler, { passive: true });
    window.addEventListener("load", animateOnScroll);
    animateOnScroll(); // kick once
  }

  // === FADE-IN OBSERVER FOR .border-wrapper AND .img5 (unchanged) ===
  function setupObserver() {
    if (!isDesktop()) return;
    const fadeInTargets = [
      ...document.querySelectorAll(".travel-collage .border-wrapper, .travel-collage .img5")
    ];

    fadeInTargets.forEach(el => {
      el.style.opacity = "0";
      el.style.transition = "opacity 0.8s ease";
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.5) {
          entry.target.style.opacity = "1";
        }
      });
    }, { threshold: 0.5 });

    fadeInTargets.forEach(el => observer.observe(el));
  }

  // Initialize
  if (isDesktop()) {
    setupScroll();
    setupObserver();
  }

  // Handle breakpoint changes (optional resilience)
  window.addEventListener("resize", () => {
    const shouldBeDesktop = isDesktop();

    // If we were listening and now not desktop, remove listener
    if (!shouldBeDesktop && onScrollHandler) {
      window.removeEventListener("scroll", onScrollHandler, { passive: true });
      onScrollHandler = null;
    }

    // If we switch into desktop, set up fresh
    if (shouldBeDesktop && !onScrollHandler) {
      setupScroll();
      setupObserver();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-events"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const section   = document.querySelector(".travel-events");
  if (!section) return;

  const menuItems = Array.from(section.querySelectorAll(".travel-menu-item"));
  const bios      = Array.from(section.querySelectorAll(".travel-bio-item"));
  const menuWrap  = section.querySelector(".travels-menu");

  let current = 0;

  function showIndex(i, opts = {}) {
    if (!bios.length) return;

    // wrap index
    i = (i + bios.length) % bios.length;
    current = i;

    // clear states
    menuItems.forEach(mi => mi.classList.remove("active"));
    bios.forEach(b => { b.classList.remove("active"); b.classList.add("hidden"); });

    // activate current
    const activeMenu = menuItems[i];
    const activeBio  = bios[i];

    if (activeMenu) activeMenu.classList.add("active");
    if (activeBio) {
      activeBio.classList.remove("hidden");
      void activeBio.offsetWidth; // reflow to enable transition
      activeBio.classList.add("active");
    }

    // keep the active menu item in view
    if (!opts.suppressScroll && activeMenu && menuWrap) {
      const isMobileHorizontal = window.matchMedia("(max-width: 600px)").matches;

      if (isMobileHorizontal) {
        // horizontal scroll on mobile
        menuWrap.scrollTo({
          left: activeMenu.offsetLeft - menuWrap.clientWidth * 0.05,
          behavior: "smooth"
        });
      } else {
        // vertical scroll inside the left menu column ONLY
        // compute a target top so the item sits near the top with a little padding
        const targetTop = activeMenu.offsetTop - menuWrap.clientHeight * 0.1;
        menuWrap.scrollTo({
          top: Math.max(0, targetTop),
          behavior: "smooth"
        });
      }
    }

    // optional focus return for prev/next buttons
    if (opts.focusButton === "prev") {
      activeBio?.querySelector(".prev")?.focus();
    } else if (opts.focusButton === "next") {
      activeBio?.querySelector(".next")?.focus();
    }
  }

  // clicks on left menu items
  menuItems.forEach((item, idx) => {
    item.addEventListener("click", () => showIndex(idx));
  });

  // delegate clicks for .prev / .next
  section.addEventListener("click", (e) => {
    const prev = e.target.closest(".prev");
    const next = e.target.closest(".next");
    if (prev) {
      e.preventDefault();
      showIndex(current - 1, { focusButton: "prev" });
    } else if (next) {
      e.preventDefault();
      showIndex(current + 1, { focusButton: "next" });
    }
  });

  // make .prev / .next accessible as buttons
  section.querySelectorAll(".prev, .next").forEach(el => {
    el.setAttribute("role", "button");
    el.setAttribute("tabindex", "0");
  });

  // arrow key support when section is focused
  section.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft")  showIndex(current - 1, { focusButton: "prev" });
    if (e.key === "ArrowRight") showIndex(current + 1, { focusButton: "next" });
  });

  // initial render: do NOT auto-scroll anything
  showIndex(0, { suppressScroll: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-faqs"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function () {
  // Initially hide all dropdowns
  $('.dropdown').hide();

  $('.travel-faq .heading').on('click', function () {
    const dropdown = $(this).next('.dropdown');
    const icon = $(this).find('.open');

    // Toggle the dropdown
    dropdown.slideToggle();

    // Toggle rotation class
    $(this).toggleClass('open');

    // Rotate the icon
    icon.toggleClass('rotated');
  });
});


  

  } catch(e) { console.error(e); }
})();
})();
